var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container sorting-metric-report" },
    [
      _c(
        "el-card",
        { staticClass: "page-card page-intro", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "intro-main" }, [
            _c("div", { staticClass: "intro-heading" }, [
              _c("div", { staticClass: "intro-title-row" }, [
                _c("div", { staticClass: "page-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("CenterForSorting.sortingMetricReport"))
                  ),
                ]),
                _c("div", { staticClass: "page-desc" }, [
                  _vm._v(
                    _vm._s(_vm.$t("CenterForSorting.sortingMetricReportDesc"))
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "intro-meta",
          class: { "intro-meta--compact": _vm.isIntroMetaCompact },
        },
        [
          _c(
            "div",
            { staticClass: "meta-item" },
            [
              _c("div", { staticClass: "meta-label" }, [
                _vm._v(_vm._s(_vm.$t("CenterForSorting.machine"))),
              ]),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.currentMachineLabel,
                    effect: "dark",
                    placement: "top",
                  },
                },
                [
                  _c("div", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.currentMachineLabel)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "meta-item" },
            [
              _c("div", { staticClass: "meta-label" }, [
                _vm._v(_vm._s(_vm.$t("CenterForSorting.sortingTimeDimension"))),
              ]),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.currentQueryTypeLabel,
                    effect: "dark",
                    placement: "top",
                  },
                },
                [
                  _c("div", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.currentQueryTypeLabel)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "meta-item" },
            [
              _c("div", { staticClass: "meta-label" }, [
                _vm._v(_vm._s(_vm.$t("CenterForSorting.sortingStatisticType"))),
              ]),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.currentMetricLabel,
                    effect: "dark",
                    placement: "top",
                  },
                },
                [
                  _c("div", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.currentMetricLabel)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "meta-item meta-item--range" }, [
            _c("div", { staticClass: "meta-label" }, [
              _vm._v(_vm._s(_vm.$t("CenterForSorting.sortingReportTimeRange"))),
            ]),
            _c(
              "div",
              { staticClass: "meta-range-row" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.reportTimeRangeText,
                      effect: "dark",
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "meta-value meta-value--small" }, [
                      _vm._v(_vm._s(_vm.reportTimeRangeText)),
                    ]),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "meta-refresh-btn",
                    attrs: {
                      icon: "el-icon-refresh",
                      size: "mini",
                      loading: _vm.isFetchingDashboard,
                    },
                    on: { click: _vm.handleManualRefresh },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("CenterForSorting.refresh")) + " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.pageLoading,
              expression: "pageLoading",
            },
          ],
          staticClass: "page-card filter-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            { staticClass: "metric-tab-bar" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "metric-tabs",
                  on: { "tab-click": _vm.handleMetricTabClick },
                  model: {
                    value: _vm.activeMetricType,
                    callback: function ($$v) {
                      _vm.activeMetricType = $$v
                    },
                    expression: "activeMetricType",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingChuteStat"),
                      name: "1",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingSupplyTableStat"),
                      name: "2",
                    },
                  }),
                  _c("el-tab-pane", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingRuleHitStat"),
                      name: "3",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.currentMetricDesc,
                    effect: "dark",
                    placement: "top",
                  },
                },
                [
                  _c("div", { staticClass: "metric-desc-trigger" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CenterForSorting.sortingMetricDescLabel")
                        )
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticClass: "filter-form",
              attrs: {
                inline: true,
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CenterForSorting.machine") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                        clearable: "",
                        filterable: "",
                      },
                      on: { change: _vm.handleMachineChange },
                      model: {
                        value: _vm.queryForm.machineCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "machineCode", $$v)
                        },
                        expression: "queryForm.machineCode",
                      },
                    },
                    _vm._l(_vm.machineList, function (item) {
                      return _c("el-option", {
                        key: item.machineCode,
                        attrs: {
                          label:
                            item.machineName + "(" + item.machineCode + ")",
                          value: item.machineCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.sortingTimeDimension"),
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                      },
                      on: { change: _vm.handleQueryTypeChange },
                      model: {
                        value: _vm.queryForm.queryType,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "queryType", $$v)
                        },
                        expression: "queryForm.queryType",
                      },
                    },
                    _vm._l(_vm.queryTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: {
                          label: _vm.$t(item.labelKey),
                          value: item.value,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.showSupplyTableFilter
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CenterForSorting.supplyTable") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "CenterForSorting.pleaseChoose"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryForm.supplyTableType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "supplyTableType", $$v)
                            },
                            expression: "queryForm.supplyTableType",
                          },
                        },
                        _vm._l(_vm.supplyTableTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showCustomTime
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CenterForSorting.timeRange") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("CenterForSorting.endTime"),
                          "start-placeholder": _vm.$t(
                            "CenterForSorting.startTime"
                          ),
                          type: "datetimerange",
                          "unlink-panels": "",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.queryForm.customTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "customTime", $$v)
                          },
                          expression: "queryForm.customTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-search",
                        size: "mini",
                        type: "primary",
                      },
                      on: { click: _vm.handleSearch },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CenterForSorting.search")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "mini" },
                      on: { click: _vm.resetQuery },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CenterForSorting.reset")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "summary-grid" },
        _vm._l(_vm.summaryCards, function (card) {
          return _c(
            "div",
            {
              key: card.key,
              staticClass: "summary-card",
              class: "summary-card--" + card.tone,
            },
            [
              _c(
                "div",
                { staticClass: "summary-label" },
                [
                  _c("span", [_vm._v(_vm._s(card.label))]),
                  card.tooltip
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: card.tooltip,
                            effect: "dark",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "el-icon-warning-outline summary-info-icon",
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: String(card.value || "-"),
                    effect: "dark",
                    placement: "top",
                  },
                },
                [
                  _c("div", { staticClass: "summary-value" }, [
                    _vm._v(_vm._s(card.value)),
                  ]),
                ]
              ),
              _c("div", { staticClass: "summary-extra" }, [
                _vm._v(_vm._s(card.extra)),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "dashboard-grid" },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.pageLoading,
                  expression: "pageLoading",
                },
              ],
              staticClass: "page-card chart-card",
              attrs: { shadow: "never" },
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("div", [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.overviewTitle)),
                  ]),
                  _c("div", { staticClass: "section-desc" }, [
                    _vm._v(" " + _vm._s(_vm.overviewRangeText) + " "),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "header-tags" },
                  [
                    _c("span", { staticClass: "info-tag" }, [
                      _vm._v(_vm._s(_vm.currentMetricLabel)),
                    ]),
                    _c("span", { staticClass: "info-tag" }, [
                      _vm._v(_vm._s(_vm.currentQueryTypeLabel)),
                    ]),
                    _c("span", { staticClass: "info-tag" }, [
                      _vm._v(_vm._s(_vm.realtimeStatusText)),
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "download-btn",
                        attrs: { icon: "el-icon-download", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadChartImage("overview")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CenterForSorting.downloadImage")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", {
                ref: "overviewChart",
                staticClass: "chart chart-large",
              }),
            ]
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.pageLoading,
                  expression: "pageLoading",
                },
              ],
              staticClass: "page-card chart-card ranking-card",
              attrs: { shadow: "never" },
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("div", [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.rankingTitle)),
                  ]),
                  _c("div", { staticClass: "section-desc" }, [
                    _vm._v(_vm._s(_vm.rankingTip)),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "header-tags" },
                  [
                    _c("span", { staticClass: "info-tag" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.activeDimensionLabel) +
                          ": " +
                          _vm._s(_vm.formatNumber(_vm.dimensionItems.length)) +
                          " "
                      ),
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "download-btn",
                        attrs: { icon: "el-icon-download", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadChartImage("ranking")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CenterForSorting.downloadImage")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", {
                ref: "rankingChart",
                staticClass: "chart chart-ranking",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "dashboard-grid detail-grid" },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.pageLoading,
                  expression: "pageLoading",
                },
              ],
              staticClass: "page-card table-card",
              attrs: { shadow: "never" },
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("div", [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.summaryTitle)),
                  ]),
                  _c("div", { staticClass: "section-desc" }, [
                    _vm._v(_vm._s(_vm.summaryTip)),
                  ]),
                ]),
                _c("div", { staticClass: "header-tags" }, [
                  _c("span", { staticClass: "info-tag" }, [
                    _vm._v(_vm._s(_vm.dimensionLabel)),
                  ]),
                ]),
              ]),
              _c(
                "el-table",
                {
                  ref: "dimensionTable",
                  attrs: {
                    data: _vm.dimensionItems,
                    "empty-text": _vm.$t("CenterForSorting.noData"),
                    height: 480,
                    border: "",
                    "highlight-current-row": "",
                    "row-key": "dimensionKey",
                  },
                  on: { "row-click": _vm.handleDimensionSelect },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.ind"),
                      align: "center",
                      type: "index",
                      width: "60",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.dimensionNameLabel,
                      "min-width": "140",
                      prop: "dimensionName",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingCurrentTotal"),
                      align: "right",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(row.compareData.currentTotal)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingPreviousTotal"),
                      align: "right",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatNumber(
                                    row.compareData.previousTotal
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingCompareRatio"),
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.getRatioTagType(
                                    row.compareData.ratio,
                                    row.compareData.comparable
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getCompareRatioText(row.compareData)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.sortingRealtime"),
                      align: "center",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: row.realtime ? "success" : "info",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.realtime
                                        ? _vm.$t("CenterForSorting.yes")
                                        : _vm.$t("CenterForSorting.no")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.pageLoading,
                  expression: "pageLoading",
                },
              ],
              staticClass: "page-card chart-card",
              attrs: { shadow: "never" },
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("div", [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.detailTitle)),
                  ]),
                  _c("div", { staticClass: "section-desc" }, [
                    _vm._v(_vm._s(_vm.detailTip)),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "header-tags" },
                  [
                    _c("span", { staticClass: "info-tag" }, [
                      _vm._v(_vm._s(_vm.detailCurrentTotalText)),
                    ]),
                    _c("span", { staticClass: "info-tag" }, [
                      _vm._v(_vm._s(_vm.detailRatioText)),
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "download-btn",
                        attrs: { icon: "el-icon-download", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadChartImage("detail")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CenterForSorting.downloadImage")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", {
                ref: "detailChart",
                staticClass: "chart chart-detail",
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }